import React, { useState } from "react";
import { v4 as uuidv4 } from 'uuid';
// import './QuestionCheckbox.css'

const QuestionCheckbox = ({ options, callback }) => {
  const [ checkboxes, setCheckboxes ] = useState(options.groups || []);
  const handleClick = (e) => {
    const answer = e.target.value;
    const checkStatus = e.target.checked;
    let allAnswers = checkboxes
    options.options.map( (c) => {
      if(c.option == answer)
        c.checked = checkStatus;
    });

    if(allAnswers.includes(answer)) {
      allAnswers = allAnswers.replace(answer, '');
    } else {
      allAnswers = allAnswers + ',' + answer;
    }

    allAnswers = allAnswers.replace(/,\s*$/, "");
    allAnswers = allAnswers.replace(/^,/, '');
    setCheckboxes(allAnswers);
    console.log(allAnswers);
    callback(checkboxes);
  }

  let number = 0;

  return (
    <>
      {options ? options.options.map( (item) => {
        number = number + 1;
        return (
          <div key={uuidv4()}>
            <div className={"inline-block relative mb-10"} key={uuidv4()}>
              <input
                onClick={handleClick}
                className="option"
                type='checkbox'
                key={uuidv4()}
                defaultChecked={item.checked}
                name={options.heading} 
                value={item.option} 
                id={'option-' + number}
              />
              <label  
                className="text-base sm:text-2xl font-medium" 
                htmlFor={'option-' + number}>
                  { item.option }
              </label>
            </div>
          </div>
        )
      }):null}
    </>
  );
};

export default QuestionCheckbox;
